import { gql } from '@apollo/client';
import { setCookie, getTokenFromCookies } from '../hooks/useCookie';
import { setCode, setLocalStorage } from '../hooks/useLocalStorage';
import { getCOPrequalDetailsByID } from './prequal.api';

// const localStore = useLocalStorage();
const CHANGE_OFFER = `
    amount
    brand
    channel
    channelGroup
    uuid
    subscriptionId
    status
    prequalId
    paymentDetails
    {
      paymentMethod
      {
        partialDigits
        cardholderName
        expirationDate
        
      }
      payment
      {
        amount
        authCode
        correlationTransactionUuid
      }
    }
`;

const QUERIES = {
  CHECK_CHANGE_OFFER_ELIGIBILITY: gql`
    query changeOfferUpgradeEligibility($subscriptionId: String!, $contractRenewal: Boolean) {
      changeOfferUpgradeEligibility(
        subscriptionId: $subscriptionId
        contractRenewal: $contractRenewal
      ) {
        changeOffer
        contractRenewal
        billingType
        chargeCode
        totalAmountVatExcluded
        totalAmountVatIncluded
        totalDays
        dailyRates
        error
      }
    }
  `,
  CREATE_CHANGE_OFFER: gql`
    mutation createChangeOffer(
        $channel: String!
        $subscriptionId: Int!
        $email: String

        ) {
            createChangeOffer (
                channel:$channel
                subscriptionId: $subscriptionId,
                email: $email
            ) {
              ${CHANGE_OFFER}
            }
          }
    `,
};

// to check cross eligibility
export const checkChangeOfferEligibility = async ({ graphql, variables = {}, cookies }) => {
  try {
    const token = getTokenFromCookies(cookies); // will get it from cookies/session storage
    const requestParams = {
      ...variables,
      token,
      offerType: 'POSTPAY',
    };
    const { data } = await graphql.query({
      query: QUERIES.CHECK_CHANGE_OFFER_ELIGIBILITY,
      requestParams,
    });
    return data.changeOfferUpgradeEligibility;
  } catch (err) {
    throw new Error(err);
  }
};

// create changeOfferRequest
export const changeOfferRequest = async ({
  graphql,
  subscriptionId = '',
  channel = '',
  email = '',
  cookies,
}) => {
  try {
    const token = getTokenFromCookies(cookies);
    const { data } = await graphql.mutate({
      mutation: QUERIES.CREATE_CHANGE_OFFER,
      variables: { subscriptionId, token, channel, email },
    });
    if (data) {
      setCode('CO');
      setLocalStorage('prequalid', data.createChangeOffer.prequalId);
      setLocalStorage('REF', data.createChangeOffer.uuid);
      setLocalStorage('subscriptionID', subscriptionId);
      setCookie('CO', 'subscription_ID', subscriptionId);
      setCookie('CO', 'reference', data.createChangeOffer.uuid);
      setCookie('ION', 'cart_Type', 'CHANGE_OFFER');
      // get prequal result
      await getCOPrequalDetailsByID(graphql, data.createChangeOffer.prequalId);
    }
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

// create changeOfferMobileRequest
export const changeOfferMobileRequest = async ({
  graphql,
  subscriptionId = '',
  channel = '',
  email = '',
  cookies,
}) => {
  try {
    const token = getTokenFromCookies(cookies);
    const result = await graphql.mutate({
      mutation: QUERIES.CREATE_CHANGE_OFFER,
      variables: { subscriptionId, token, channel, email },
    });
    if (result) {
      setCode('CO');
      setLocalStorage('REF', result.data?.createChangeOffer?.uuid);
      setLocalStorage('PROSPECTUUID', result.data?.createChangeOffer?.uuid);
      setLocalStorage('subscriptionID', subscriptionId);
      setCookie('CO', 'subscription_ID', subscriptionId);
      setCookie('CO', 'reference', result.data?.createChangeOffer?.uuid);
      setCookie('ION', 'cart_Type', 'CHANGE_OFFER');
    }
    return { result, error: null };
  } catch (err) {
    return { result: null, error: err };
  }
};
